import {
    BENEFICIARY_TYPE_OPTIONS,
    EXPENSE_CATEGORY_OPTIONS,
    type SelectOption,
} from '../../../../types/LegalCase';
import type { FilterDef } from './filterTypes';

// Opções do filtro "com/sem processo": choice mutuamente exclusivo que mapeia para o
// parâmetro `hasCase` (tri-estado no backend: ausente = todas). Ver useExpensesPage.
const HAS_CASE_OPTIONS: SelectOption[] = [
    { value: 'true', label: 'Com processo' },
    { value: 'false', label: 'Sem processo' },
];

// Filtros da página de Despesas (drawer + chips), no mesmo modelo data-driven da grid de
// Casos. `beneficiary` recebe as opções em runtime (lista de beneficiários cadastrados), por
// isso é montado por função. Categoria e "com/sem processo" são estáticos.
export const buildExpenseFilterDefs = (
    beneficiaryOptions: SelectOption[],
): FilterDef[] => [
    {
        id: 'category',
        label: 'Categoria',
        kind: 'select',
        options: EXPENSE_CATEGORY_OPTIONS,
        emptyLabel: 'Qualquer categoria',
    },
    {
        id: 'hasCase',
        label: 'Processo',
        kind: 'choice',
        options: HAS_CASE_OPTIONS,
        // O backend lê `hasCase` como booleano tri-estado; o valor do choice já é 'true'/'false'.
        toQuery: (value) => (value === 'true' ? true : value === 'false' ? false : undefined),
        formatValue: (v) => (v === 'true' ? 'com processo' : 'sem processo'),
    },
    {
        id: 'beneficiaryId',
        label: 'Beneficiário',
        kind: 'select',
        options: beneficiaryOptions,
        emptyLabel: 'Qualquer beneficiário',
    },
];

// Estático para quando o beneficiário ainda não carregou (drawer abre sem travar).
export const EXPENSE_FILTER_DEFS: FilterDef[] = buildExpenseFilterDefs([]);

// Filtros da página de Beneficiários: só o tipo, por ora.
export const BENEFICIARY_FILTER_DEFS: FilterDef[] = [
    {
        id: 'type',
        label: 'Tipo',
        kind: 'select',
        options: BENEFICIARY_TYPE_OPTIONS,
        emptyLabel: 'Qualquer tipo',
    },
];
